import React from 'react';
import AddOrEditGodownForm from './AddOrEditGodownForm';

const CreateGodownScreen = () => {
  return <AddOrEditGodownForm mode="add" />;
};

export default CreateGodownScreen;
